<template>
  <div id="canvas"
       style="position:relative; display: flex; flex-direction: column; justify-content: center; align-items: center;">

<!--    SHOWS THE TAKEN PICTURE-->
    <canvas ref="imgCanvas" style="position: absolute"></canvas>

<!--    SHOWS THE PICTURE WITH A BLURRED BACKGROUND-->
    <img v-if="finalUrl != null" :src="finalUrl" ref="finalImageCanvas" style="position: absolute" class="finalImage">

<!--    THE SQUARE AND THE DOTS FOR THE SCANNER-->
    <div ref="face" style="position: absolute; margin-top: -25px">
      <svg viewBox="0 0 100 100" :width="width" :height="width" id="viewBox" style="margin-top: -25px">

        <!--        OUTSIDE BORDER CORNERS-->
        <path d="M25,0 L0,0 L0,25" fill="none" stroke="white" :stroke-width="strokeWidth"></path>
        <path d="M0,75 L0,100 L25,100" fill="none" stroke="white" :stroke-width="strokeWidth"></path>
        <path d="M75,100 L100,100 L100,75" fill="none" stroke="white" :stroke-width="strokeWidth"></path>
        <path d="M100,25 L100,0 L75,0" fill="none" stroke="white" :stroke-width="strokeWidth"></path>

        <!--        QUADRANT CIRCLES-->
        <circle id="quadA" r="1" stroke="white" stroke-width="2px" opacity="1" fill-opacity="1" fill="white"
                class="path"></circle>
        <circle id="quadB" r="1" stroke="white" stroke-width="2px" opacity="1" fill-opacity="1" fill="white"
                class="path"></circle>
        <circle id="quadC" r="1" stroke="white" stroke-width="2px" opacity="1" fill-opacity="1" fill="white"
                class="path"></circle>
        <circle id="quadD" r="1" stroke="white" stroke-width="2px" opacity="1" fill-opacity="1" fill="white"
                class="path"></circle>
        <circle id="quadE" r="1" stroke="white" stroke-width="2px" opacity="1" fill-opacity="1" fill="white"
                class="path"></circle>
        <circle id="quadF" r="1" stroke="white" stroke-width="2px" opacity="1" fill-opacity="1" fill="white"
                class="path"></circle>
      </svg>
    </div>

<!--    USED TO DRAW THE LINES ON THE FACE-->
    <div id="face" style="position: absolute;"></div>
  </div>

</template>

<script>
  import Raphael from 'raphael';

  export default {
    name: "FaceScanner",
    props:{
      finalUrl: {
        required: false,
        default: null
      },
    },
    data() {
      return {
        hideFaceScanner:true,
        width: '0px',
        box: null,
        strokeWidth: 5,
        quadrantPairsTemplate: [
          ['A', 'B'],
          ['A', 'E'],
          ['A', 'C'],
          ['B', 'D'],
          ['B', 'E'],
          ['C', 'E'],

          ['E', 'D'],
          ['F', 'C'],
          ['F', 'D'],
        ],
        quadrantPairs: [],
        colors: {
          primary: '#1E496C',
          secondary: '#013B6C',
          accent: '#82B1FF',
        },
        killRecursion:false,
      }
    },
    watch:{
      finalUrl: (val)=>{
        if(val != null) {
          document.getElementById('face').style.display = 'none';
        }
      }
    },
    methods: {
      startScanningFace(detection) {
        this.hideFaceScanner = false;

        //This timeout is to delay the face scanner to first check if the user has an internet connection
        //If they do not have an internet connection and the facescanner starts, it will flash and go away (hence the timeout)
        this._startScanningFaceTimeout = setTimeout(()=>{
          this._detection = detection;
          this.width = detection.box.width + 'px';
          this.left = detection.box.left + 'px';
          this.top = (+detection.box.top) + 'px';
          this.$refs.face.setAttribute('style', 'width: ' + parseInt(detection.box.width) + 'px; height: ' + parseInt(detection.box.width) + 'px; left: ' + parseInt(detection.box.left) + 'px; top: ' + parseInt(detection.box.top) + 'px; position: absolute');
          document.getElementById('face').innerHTML = '';
          document.getElementById('face').setAttribute('style', 'width: ' + parseInt(detection.box.width) + 'px; height: ' + parseInt(detection.box.width) + 'px; left: ' + parseInt(detection.box.left) + 'px; top: ' + parseInt(detection.box.top - 25) + 'px; position: absolute');
          this.box = detection.box;
          this.clearPaths();
          this.drawPaths();
        },500);

      },
      clearPaths(){
        if(this._paper!=null){
          this._paper.clear();
          this._paper = null;
        }
      },
      drawPaths() {

        const detection = this._detection;
        this._paper = Raphael("face", parseInt(detection.box.width), parseInt(detection.box.width));
        document.getElementById('face').firstChild.setAttribute('viewBox', '0 0 100 100');

        this.quadrantPairs = JSON.parse(JSON.stringify(this.quadrantPairsTemplate));

        let svgBox = document.getElementById('viewBox').getBBox();

        let quadA = {
          left: {
            min: 8,
            max: svgBox.width / 4,
          },
          top: {
            min: 8,
            max: svgBox.height / 5,
          },
        };

        let quadB = {
          left: {
            min: (svgBox.width * (3 / 4)),
            max: svgBox.width - 8,
          },
          top: {
            min: 8,
            max: (svgBox.height / 5) + 8,
          },
        };

        let quadC = {
          left: {
            min: 8,
            max: svgBox.width / 4,
          },
          top: {
            min: (svgBox.height * (4 / 5)) - 8,
            max: svgBox.height - 8,
          },
        };

        let quadD = {
          left: {
            min: svgBox.width * (3 / 4),
            max: svgBox.width - 8,
          },
          top: {
            min: svgBox.height * (4 / 5),
            max: svgBox.height - 8,
          },
        };

        let quadE = {
          left: {
            min: (svgBox.width / 2) - 10,
            max: (svgBox.width / 2) + 10,
          },
          top: {
            min: (svgBox.height / 2) - 10,
            max: (svgBox.height / 2) + 10,
          },
        };

        let quadF = {
          left: {
            min: (svgBox.width / 2) - 10,
            max: (svgBox.width / 2) + 10,
          },
          top: {
            min: svgBox.height -8,
            max: svgBox.height -8,
          },
        };

        this._coordinates = {};

        this._coordinates['A'] = {
          x: this.getRandomInteger(parseInt(quadA.left.min), parseInt(quadA.left.max)),
          y: this.getRandomInteger(parseInt(quadA.top.min), parseInt(quadA.top.max)),
        };

        this._coordinates['B'] = {
          x: this.getRandomInteger(parseInt(quadB.left.min), parseInt(quadB.left.max)),
          y: this.getRandomInteger(parseInt(quadB.top.min), parseInt(quadB.top.max)),
        };

        this._coordinates['C'] = {
          x: this.getRandomInteger(parseInt(quadC.left.min), parseInt(quadC.left.max)),
          y: this.getRandomInteger(parseInt(quadC.top.min), parseInt(quadC.top.max)),
        };

        this._coordinates['D'] = {
          x: this.getRandomInteger(parseInt(quadD.left.min), parseInt(quadD.left.max)),
          y: this.getRandomInteger(parseInt(quadD.top.min), parseInt(quadD.top.max)),
        };

        this._coordinates['E'] = {
          x: this.getRandomInteger(parseInt(quadE.left.min), parseInt(quadE.left.max)),
          y: this.getRandomInteger(parseInt(quadE.top.min), parseInt(quadE.top.max)),
        };

        this._coordinates['F'] = {
          x: this.getRandomInteger(parseInt(quadF.left.min), parseInt(quadF.left.max)),
          y: this.getRandomInteger(parseInt(quadF.top.min), parseInt(quadF.top.max)),
        };

        this.drawCircle('A', this._coordinates['A'].x, this._coordinates['A'].y);
        this.drawCircle('B', this._coordinates['B'].x, this._coordinates['B'].y);
        this.drawCircle('C', this._coordinates['C'].x, this._coordinates['C'].y);
        this.drawCircle('D', this._coordinates['D'].x, this._coordinates['D'].y);
        this.drawCircle('E', this._coordinates['E'].x, this._coordinates['E'].y);
        this.drawCircle('F', this._coordinates['F'].x, this._coordinates['F'].y);

        //Loop through the pairs and draw a random pair
        const len = this.quadrantPairs.length;
        this.killRecursion = false;
        this.animateLine(1, len);

      },
      animateLine(iteration, maxIterations) {

        if(this.killRecursion) return;

        const random = this.getRandomInteger(0, this.quadrantPairs.length - 1);

        this.drawLine(
          {
            x: this._coordinates[this.quadrantPairs[random][0]].x,
            y: this._coordinates[this.quadrantPairs[random][0]].y
          },
          {
            x: this._coordinates[this.quadrantPairs[random][1]].x,
            y: this._coordinates[this.quadrantPairs[random][1]].y
          }
        ).then(() => {

            this.$delete(this.quadrantPairs, random);

            if (iteration < maxIterations) {
              this.animateLine(++iteration, maxIterations);
            } else { //restart

              setTimeout(()=>{
                this.clearPaths();
                this.drawPaths();
              },1000);

            }
          }
        );
      },
      drawCircle(quadrant, left, top) {
        document.getElementById('quad' + quadrant).setAttribute('cx', left);
        document.getElementById('quad' + quadrant).setAttribute('cy', top);
      },
      drawLine(a, b) {
        return new Promise((resolve) => {
            this._paper.path(`M ${a.x} ${a.y}`).attr({
              stroke: '#eee',
              'stroke-width': '1px',
              opacity: '0.9',
            }).animate({path: `M ${a.x} ${a.y} L ${b.x} ${b.y}`}, 800, () => resolve());
        });
      },
      getRandomInteger(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      stopScanningFace(){
        clearTimeout(this._startScanningFaceTimeout);
        // this.clearPaths();
        this.killRecursion = true;
        this.box=null;
        this.hideFaceScanner = true;
        this.$nextTick(()=>{
          this.width='0px';
        });

        document.getElementById('viewBox').setAttribute('width','0px');
        document.getElementById('viewBox').setAttribute('height','0px');

        document.getElementById('face').innerHTML = '';
      }
    },
    beforeDestroy(){
      // this.clearPaths();
      // this.killRecursion = true;
      this.stopScanningFace();
      this.clearPaths();
    },
  }
</script>

<style scoped>
  .path {
    /*stroke-dasharray: 100;*/
    /*animation: dash 4s !important;*/
  }

  @keyframes dash {
    from {
      stroke-dashoffset: 0
    }
    to {
      stroke-dashoffset: 200;
    }
  }

  @keyframes crossFade {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 0;
    }
    60% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }

  .finalImage {
    animation-name: crossFade;
    animation-timing-function: ease-in-out;
    animation-duration: 4s;
    animation-direction: alternate;
  }
</style>
